import { useCallback, useEffect, useState } from 'react';

export default function useScript (url: string): boolean {
  const scriptUrl = url.toLowerCase();

  const getScript = useCallback((url: string): HTMLScriptElement | null => {
    const script: HTMLScriptElement | null = document.head.querySelector(`script[src="${url}"]`);

    return script;
  }, []);

  const [loaded, setLoaded] = useState(!!getScript(scriptUrl));

  useEffect(() => {
    let script = getScript(scriptUrl);

    if (script) {
      return;
    }

    script = document.createElement('script');

    script.src = scriptUrl;
    script.async = true;
    script.addEventListener('load', () => setTimeout(() => setLoaded(true), 100));

    document.head.appendChild(script);

    return () => {
      if (script) {
        document.head.removeChild(script);
      }
    };
  }, [scriptUrl, getScript]);

  return loaded;
}
